import { useState, useEffect } from 'react'
import { Spinner, Tag } from '@blueprintjs/core'
import { useSearchParams } from 'react-router-dom'
import { useApi } from '../contexts/ApiProvider'
import { AppToaster } from '../components/toaster'
import ControlsPanel from '../components/sandbox/ControlsPanel'
import SandboxTable from '../components/sandbox/SandboxTable'

export default function SandboxPage() {
  const api = useApi()
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(false)
  const [searchParams] = useSearchParams()

  const surveyId = searchParams.get('surveyId')
  const bannerParam = searchParams.get('banner')
  const stubParam = searchParams.get('stub')
  const filterParam = searchParams.get('filter')

  const isSurveyMode = !!(surveyId && bannerParam && stubParam)

  const handleApply = async (params) => {
    setLoading(true)

    try {
      let response
      if (isSurveyMode) {
        response = await api.post('/sandbox/survey-impact-scores', {
          ...params,
          banner: bannerParam.split(',').filter(Boolean).map(Number),
          stub: stubParam.split(',').filter(Boolean).map(Number),
          filter: filterParam ? filterParam.split(',').filter(Boolean).map(Number) : [],
        })
      } else {
        response = await api.post('/sandbox/impact-scores', params)
      }

      if (response.ok) {
        setData(response.body)
      } else {
        AppToaster.show({
          message: 'Failed to load impact scores.',
          intent: 'danger',
        })
      }
    } catch (err) {
      AppToaster.show({
        message: 'Failed to load impact scores.',
        intent: 'danger',
      })
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    handleApply({})
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div>
      <div style={{ padding: '8px 20px', background: isSurveyMode ? '#e8f0fe' : '#fff3cd', borderBottom: '1px solid #ccc' }}>
        {isSurveyMode ? (
          <><Tag minimal>Survey {surveyId}</Tag>{' '}Comparing impact scores for real survey data</>
        ) : (
          <><Tag minimal intent="warning">Synthetic Data</Tag>{' '}This data is fabricated for testing purposes. Use "Open in Sandbox" from an index table to compare real survey data.</>
        )}
      </div>
      <ControlsPanel onApply={handleApply} loading={loading} />
      {loading && !data && (
        <div style={{ padding: '40px', textAlign: 'center' }}>
          <Spinner />
        </div>
      )}
      <SandboxTable data={data} />
    </div>
  )
}
